import { render } from "./UserSubscriptionHistory.vue?vue&type=template&id=452211c7&scoped=true"
import script from "./UserSubscriptionHistory.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionHistory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452211c7"]])

export default __exports__